import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svg_i-dot",
  "use": "svg_i-dot-usage",
  "viewBox": "0 0 8 8",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 8 8\" id=\"svg_i-dot\"><circle cx=\"4\" cy=\"4\" r=\"4\" fill=\"#C4C4C4\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol